import React from 'react';
import './ulits/scss/style.scss';
import { Route, Routes } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { ChildThemeLayout } from './Layout/ChildThemeLayout';
import { HelmetProvider } from 'react-helmet-async';


function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <Routes>
      <Route path="/*" element={<ChildThemeLayout />} />;
      </Routes>
      </HelmetProvider>
    </div>
  );
}

export default App;
